import { useState } from 'react'
import { Outlet, useLocation, useOutletContext } from 'react-router-dom'
import Topbar from './Topbar.jsx'
import AssistantPanel from './AssistantPanel.jsx'
// DataProvider is now mounted once in <Shell>, so it covers both the app pages
// and the full-screen wizards (which also need manifest access).

// Inner layout for the signed-in app pages. The persistent sidebar is provided
// by the parent <Shell>; this renders the right-hand column (topbar + padded
// content) plus the AI assistant, which slides in as a full-height drawer from
// the right. Its trigger lives in the Topbar next to the notifications bell.
// Pages that span the whole content pane and frame their own content. The
// shell box below is capped at 1400px, centred and padded, so a page that
// scrolls INSIDE itself had its scroll area — and its scrollbar — stop short
// of the pane's edges on a wide screen (2026-10-13, Activity: "the scroll view
// needs to span the entire panel"). These pages get the bare box and put the
// same max-width and padding on their own children instead
// (Activity.jsx PAGE_FRAME), so nothing moves but the scrollbar.
const SELF_FRAMED = ['/performance/activity']

export default function AppLayout() {
  const [assistantOpen, setAssistantOpen] = useState(false)
  // Shell owns the phone nav drawer; the menu button lives in the Topbar.
  const { onOpenNav } = useOutletContext() || {}
  const { pathname } = useLocation()
  const selfFramed = SELF_FRAMED.some((p) => pathname === p || pathname.startsWith(`${p}/`))

  return (
    <>
      <div className="flex h-full flex-1 flex-col overflow-hidden bg-panel">
        <Topbar
          assistantOpen={assistantOpen}
          onToggleAssistant={() => setAssistantOpen((v) => !v)}
          onOpenNav={onOpenNav}
        />
        {/* Bounded, scrollable content area. Tall pages scroll here (block flow,
            so padding stays correct); pages that opt into filling set their root
            to `h-full flex-col` and let their own body be the scroll region.
            Padding is symmetric 24px. It used to be padded out to 48 at the
            bottom to stop the Events footer clipping, but that footer was being
            clipped because it sat outside the page's flex column — fixed there,
            so the dead band at the bottom of every page is gone. */}
        <div
          className={
            selfFramed
              ? 'min-h-0 w-full flex-1 overflow-y-auto'
              : 'mx-auto min-h-0 w-full max-w-[1400px] flex-1 overflow-y-auto p-6 max-md:p-4'
          }
        >
          <Outlet />
        </div>
      </div>
      <AssistantPanel open={assistantOpen} onClose={() => setAssistantOpen(false)} />
    </>
  )
}
